module.exports = "/_next/static/images/macpunks-story-1-e1623410001d1439d4b1d074d5abcb48.png";